import { extend } from '@thd-nucleus/data-sources';

import { ProductPod } from '@thd-olt-component-react/product-pod';

export const PromoPodDataModel = extend(ProductPod);
